module.exports = __webpack_public_path__ + "static/media/sq-0.cb61d2bc.png";